/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { App, Col, Form, FormProps, Input, Row, Button } from 'antd';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  createBannerSlider,
  getListBanner,
  // getListBanner,
  resetMessages,
  watchBannerMessage,
  showPopup
} from '@/redux/slices/banner.slice';
import { setMessages } from '@/redux/slices/app.slice';
import { Message } from '@/enums/message.enum';
import { useQuery } from '@/hooks/query.hook';
import { PageURLs } from '@/utils/navigate';
import { useDrawer } from '@/hooks/drawer.hook';
import { BannerSliderDrawer } from '../drawer/banner-slider.drawer';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { useBeforeUnload } from 'react-router-dom';
// import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
// import { RcFile } from 'antd/es/upload';
type BannerSliderCreateFormProps = {
  handleGoBack: () => void;
};

export const ChatGPTCreateForm = ({
  handleGoBack
}: BannerSliderCreateFormProps) => {
  const [form] = Form.useForm();
  const messageInfo = useAppSelector(watchBannerMessage);
  const dispatch = useAppDispatch();
  const { push } = useQuery();
  const { modal } = App.useApp();
  const { openDrawer } = useDrawer();

  const onFinish: FormProps<CreateBannerProps>['onFinish'] = async () => {
    const formData = new FormData();

    await dispatch(createBannerSlider(formData));
    await push(PageURLs.ofHomeBannerSlider());
    await dispatch(
      getListBanner({
        offset: PAGINATION_PARAMS.offset,
        limit: PAGINATION_PARAMS.limit,
        sort_by: 'ASC'
      })
    );
    if (showPopup) {
      modal.confirm({
        title: 'Sắp xếp thứ tự hiển thị Banner',
        content: <em>Bạn có muốn sắp xếp thứ tự hiển thị Banner không?</em>,
        okText: 'Có',
        width: 450,
        cancelText: 'Không',
        onOk: () => {
          openDrawer(<BannerSliderDrawer />);
          dispatch(showPopup(false));
        },
        onCancel: () => {
          dispatch(showPopup(false));
        }
      });
    }
  };

  useEffect(() => {
    if (messageInfo) {
      dispatch(
        setMessages([
          {
            type: messageInfo.type,
            message: messageInfo.message,
            description: messageInfo.description
          }
        ])
      );
      if (messageInfo.type === Message.SUCCESS) {
        form.resetFields();
        dispatch(showPopup(true));
      }
      dispatch(resetMessages());
    }
  }, [dispatch, messageInfo, form]);

  useBeforeUnload((e) => {
    e.preventDefault();
  });

  return (
    <Form
      form={form}
      name='create-banner'
      css={formStyles}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      autoComplete='off'
      className='ant-form-custom'
    >
      <div css={backgroundStyle}>
        <Form.Item<CreateBannerProps>
          label='Câu hỏi'
          name='name'
          rules={[{ required: true, message: 'Vui lòng nhập câu hỏi' }]}
        >
          <Input
            css={inputStyles}
            size='large'
            placeholder='Nhập câu hỏi của bạn'
          />
        </Form.Item>

        <Form.Item<CreateBannerProps>
          label='Câu trả lời'
          name='redirectUrl'
          rules={[{ required: true, message: 'Vui lòng nhập câu trả lời' }]}
        >
          <Input.TextArea
            css={textAreaStyles}
            size='large'
            placeholder='Nhập nội dung trả lời cho câu hỏi của bạn'
          />
        </Form.Item>
      </div>
      <div css={backgroundStyle}>
        <Row justify='center' gutter={[20, 0]}>
          <Col>
            <Button
              onClick={handleGoBack}
              type='text'
              css={actionBtnCancelStyles}
            >
              Huỷ
            </Button>
          </Col>
          <Col>
            <Button
              // loading={loading}
              css={actionBtnStyles}
              htmlType='submit'
              type='primary'
            >
              Lưu & Đóng
            </Button>
          </Col>
          <Col>
            <Button
              // loading={loading}
              css={actionBtnStyles}
              htmlType='submit'
              type='primary'
            >
              Lưu & Tạo mới
            </Button>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

const formStyles = css`
  // margin-top: 3rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  .ant-form-item {
    .ant-form-item-label {
      width: 12rem;
      text-align: left;
      font-weight: 500;
      line-height: 5rem;
    }
    .ant-form-item-row {
      align-items: center;
    }
  }
`;

const actionBtnStyles = css`
  width: 20rem;
  // font-weight: 500;
`;

const actionBtnCancelStyles = css`
  width: 20rem;
  border-color: black;
`;
const inputStyles = css`
  height: 5rem;
  width: 100%;
`;

const textAreaStyles = css`
  width: 100%;
  height: 45rem !important;
`;

const backgroundStyle = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
`;
